import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  linkText: {
    cursor: 'pointer'
  },
  fseButton: {
    marginLeft: '4px'
  },
  fseButtonLink: {
    '& .fseLink': {
      color: palette.primary.main,
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  },
  tenantInfoPaper: {
    padding: '24px',
    background: palette.gradients.white
  },
  pageWrapper: {
    position: 'relative',
    background: palette.shades[200]
  },
  pageWrapperTopPadding: {
    paddingTop: '24px'
  },
  tenantInfoContainer: {
    '& .MuiPaper-root': {
      height: '100%',
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'stretch'
    },
    '& .MuiList-root': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  },
  warningWrapper: {
    [breakpointsFunc.breakpoints.down('xl')]: {
      '& .MuiAlert-root': {
        paddingRight: '20px',
        paddingLeft: '20px'
      }
    }
  }
}));
export default useStyles;